import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

/**
 * An Entry representing the completion status of an third part inspection
 */
export class ThirdPartyInspectionDetails extends GeckoEntryBase<
  {
    status?: string
  },
  {
    organization: string
    site: string
    unit: string
    component: string
    inspection: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    const inspection = parseString(json.tags.inspection)
    const organization = parseString(json.tags.organization)
    const site = parseString(json.tags.site)
    const unit = parseString(json.tags.unit)
    const component = parseString(json.tags.component)

    const requiredTags = {
      inspection,
      organization,
      site,
      unit,
      component,
    }

    const validRequiredTags = Object.entries(requiredTags).reduce(
      (acc, [tagName, value]) => {
        if (value === undefined) {
          throw new Error(
            `ThirdPartyInspectionDetails: ${tagName} tag is required but was undefined`
          )
        }
        return { ...acc, [tagName]: value }
      },
      {
        inspection: '',
        organization: '',
        site: '',
        unit: '',
        component: '',
      }
    )

    super(
      json,
      {
        status: parseString(json.data.status),
      },
      validRequiredTags,
      {}
    )
  }

  /**
   * A simple factory method which creates a Third Part Inspection Entry
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new ThirdPartyInspectionDetails(json)
  }
}
